import packageJson from './vi.json';

export const VersionInfo = () => {
    return <span>{packageJson.version}</span>;
};
